import { render, staticRenderFns } from "./ListaLogAcciones.vue?vue&type=template&id=00d30a8f"
import script from "./ListaLogAcciones.vue?vue&type=script&lang=js"
export * from "./ListaLogAcciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports